export function operacaoBateladasInRequest(params = {}) {
  return {
    type: '@operacaobatelada/OPERACAOBATELADAS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoBatelada(id) {
  return {
    type: '@operacaobatelada/FIND_OPERACAOBATELADA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaobatelada/FAILED_REQUEST',
  };
}

export function deleteOperacaoBatelada(id, params, query = {}) {
  return {
    type: '@operacaobatelada/DELETE_OPERACAOBATELADA',
    payload: { id, params, query },
  };
}

export function updateOperacaoBatelada(operacaobatelada, params) {
  return {
    type: '@operacaobatelada/UPDATE_OPERACAOBATELADA',
    payload: { operacaobatelada, params },
  };
}

export function storeOperacaoBatelada(operacaobatelada, params) {
  return {
    type: '@operacaobatelada/STORE_OPERACAOBATELADA',
    payload: { operacaobatelada, params },
  };
}

export function successInRequest(
  operacaobateladas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaobatelada/SUCCESS_IN_REQUEST',
    payload: {
      operacaobateladas,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaobatelada) {
  return {
    type: '@operacaobatelada/SUCCESS_REQUEST',
    payload: { operacaobatelada },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaobatelada/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaobatelada/RECORD_FILTERING',
    payload: { params },
  };
}

export function update(data, params) {
  return {
    type: '@operacaobatelada/UPDATE',
    payload: { data, params },
  };
}
